import React, {useContext} from 'react';
import {Container, Sprite} from '@inlet/react-pixi';
import {CoreDI, ResourceLoader, inversifyContainer} from '@gongxigames/framework/core';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {PayContainer} from '@gongxigames/framework/slot/modules/oddsUpfront/components/PayContainer';
import {PayContainerAligner} from '@gongxigames/framework/slot/modules/oddsUpfront/components/PayContainerAligner';
import {PayTableContext} from '@gongxigames/framework/slot/modules/oddsUpfront/OddsUpfrontReactView';

type SymbolProps = {
    src: string;
    symbolId: string;
};
let LOADER: ResourceLoader|undefined;

export function SymbolComponent({src, symbolId}: SymbolProps): JSX.Element {
    const srcArray = src.trim().split(' ');
    const {style, scale, horizontalWidth, visible, maxSymbolWidth, maxSymbolHeight} = useContext(PayTableContext);
    let newScale = scale;

    const textures = srcArray.map((oneScr) => {
        LOADER ||= inversifyContainer.get<ResourceLoader>(CoreDI.ResourceLoader);

        const texture = LOADER.getTexture(oneScr);
        const {width, height} = texture;

        if (maxSymbolHeight) {
            newScale = Math.min(newScale, maxSymbolHeight / height);
        }

        if (maxSymbolWidth) {
            newScale = Math.min(newScale, maxSymbolWidth / width);
        }

        return texture;
    });

    if (maxSymbolWidth && textures.length > 1) {
        const width = textures.reduce((acc, cur) => {
            return acc + cur.width;
        }, 0);

        newScale = Math.min(newScale, maxSymbolWidth / width);
    }

    const images: JSX.Element[] = [];

    for (const [index, item] of textures.entries()) {
        const x = index * (textures[index - 1]?.width ?? 0) * newScale;

        images.push(
            <Sprite texture={item} scale={newScale} key={index} x={x}/>
        );
    }

    return (
        <FlexBoxComponent name='symbol' alignItems={'center'} justifyContent={'end'} gap={50}>
            <FlexBoxComponent name='image'>
                <Container>
                    {images}
                </Container>
            </FlexBoxComponent>
            <FlexBoxComponent name={`id_${symbolId}`} alignItems={'start'} direction={'column'} >
                <PayContainer scale={scale} symbolId={symbolId} style={style}/>
                <PayContainerAligner visible={visible} width={horizontalWidth}/>
            </FlexBoxComponent>
        </FlexBoxComponent>
    );
}
